import {
  ORDER_SEARCH as $ST,
  ORDER_CANCELLATION as $ORDER_CANCELLATION,
} from 'plugins/tfs/platformConfigs/staticTextMaps/order';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { fetchOrder } from 'actions/orderSearch';
import Error from 'theme/Error';
import TextBox from 'theme/TextBox';
import { useDispatch } from 'react-redux';

// pageContainer
import OrderSearch from '_pageContainers/orders/search';

const OrderSearchGrid = (pageContext) => {
  const dispatch = useDispatch();

  const {
    props: { pending, order, error, main },
  } = pageContext;

  const [orderData, setOrderData] = useState('');

  const [refund, setRefund] = useState(false);
  const [accept, setAccept] = useState(false);
  const [delivery, setDelivery] = useState(false);
  const [cancel, setCancel] = useState(false);

  useEffect(() => {
    if (order.pk) {
      switch (main) {
        case 'refund':
          setRefund(true);
          break;
        case 'accept':
          setAccept(true);
          break;
        case 'delivery':
          setDelivery(true);
          break;
        case 'cancel':
          setCancel(true);
          break;
        default:
          break;
      }
    }
  }, [order]);

  if (refund === true) {
    return <Redirect to={$R.ORDER_REFUND_DETAIL.path} />;
  }

  if (cancel === true) {
    return <Redirect to={$R.ORDER_CANCELLATION_DETAIL.path} />;
  }

  if (accept === true) {
    return <Redirect to={$R.ORDER_ACCEPT_COMPLETE.path} />;
  }

  if (delivery === true) {
    return <Redirect to={$R.ORDER_DELIVERY_COMPLETE.path} />;
  }

  const submitForm = (event) => {
    let formData = {
      order: orderData,
    };
    if (main === 'refund') {
      localStorage.setItem('refundOrderNumber', JSON.stringify(orderData));
      setRefund(true);
      event.preventDefault();
    } else if (main === 'cancel') {
      localStorage.setItem('cancelOrderNumber', JSON.stringify(orderData));
      setCancel(true);
      event.preventDefault();
    } else {
      event.preventDefault();
      dispatch(fetchOrder(formData, main));
    }
  };

  return (
    <div className='container-fluid user-search headerMargin'>
      <div className='user-search__container'>
        <h3 className='form-title-hero text-center'>
          {main === 'refund' && $ST.ORDER_REFUND_ACCEPTANCE}
          {main === 'accept' && $ST.SHOP_ORDER_ACCEPT}
          {main === 'delivery' && $ST.SHOP_ORDER_DELIVERY}
          {main === 'cancel' && $ORDER_CANCELLATION.ORDER_CANCEL_ACCEPTANCE}
        </h3>
        <form onSubmit={submitForm}>
          <div className='row user-search__header-container'>
            <div className='col-xs-12 col-md-7 input-area align-self-center'>
              <div className='input-area__label-wrapper text-right'>
                <label className='label-title'>{$ST.SEARCH_ORDER}</label>
              </div>
              <div className='input-area__input-wrapper'>
                <TextBox
                  name='order'
                  type='text'
                  placeholder={$ST.ORDER_NUMBER}
                  onChange={(value) => setOrderData(value)}
                  value={orderData}
                />
              </div>
            </div>
            <div className='col-xs-12 col-md-5 align-self-center'>
              <button
                type='submit'
                className='button float-left pointer'
                disabled={pending}
              >
                {$ST.SEARCH_ORDER_UPPER}
              </button>
            </div>
          </div>
          <div className='text-center'>
            <Error data={error} field='order' />
            {!pending && error && error.message}
          </div>
        </form>
      </div>
    </div>
  );
};

export default OrderSearch(OrderSearchGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/orders/searchCancellation/index.js